import { Navigate, useLocation, useParams } from "react-router-dom";

/** Redirects a legacy route without dropping its path parameters or callback query. */
export function PreservingRedirect({ to }: { to: string }) {
  const params = useParams();
  const location = useLocation();

  let targetPath = to;
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      targetPath = targetPath.replace(`:${key}`, encodeURIComponent(value));
    }
  });

  return <Navigate to={`${targetPath}${location.search}${location.hash}`} replace />;
}

export default PreservingRedirect;
